import fc from '@/firebaseConfig'

export default {
  namespaced: true,
  state: {
    loading: false,
    detail: false,
  },
  mutations: {
    setDetail(state, val) {
      state.detail = val
    },
    setLoading(state, val) {
      state.loading = val
    },
  },
  actions: {
    getDetail({commit}, {partnerID}) {
      fc.db.collection('Partners').doc(partnerID).get().then(function (partnerDetail) {
        let detail = partnerDetail.data()
        detail.id = partnerDetail.id
        commit('setDetail', [detail])
      })
    },
    getList({commit}, {refCode}) {
      commit("setLoading", true)
      fc.db.collection('Partners').where("refCode", "==", refCode).get()
        .then(function (partners) {
          let partnerArray = []
          partners.forEach((detail) => {
            let company = detail.data()
            company.id = detail.id
            partnerArray.push(company)
          });
          commit('setDetail', partnerArray)
          commit('setLoading', false)
        })
        .catch(function (error) {
          console.log("error", error)
          commit('setDetail', false)
        })
    },
  },
}
